export default "__VITE_ASSET__BeKYLE$X__"